const account = {
  accountName: '',
  timezone: '',
  currencySymbol: '',
  userInfo: {},
  readOnlyAccess: false,
  read_only_connect_routes: {},
  read_write_connect_routes: {},
  largeAccounts: [
    'sfarr@landvoice.com',
    'scrosby@landvoice.com',
  ],
  productsAndPlans: [],
  isMaster: false,
  selected_email_integration: '',
  google_api_credentials: {},
  metadata: {},
};

const automatedEmails = {
  automatedEmailData: {
    eventType: '',
    dataKey: '',
    page: '',
    days: 0,
  },
};

const calendar = {
  /* eventType -- use to filter the calendar ('all')
   * 'all'
   * 'cancellation'
   * 'expected'
   * 'potential'
   * 'delinquent'
   */
  eventType: 'all',
  calendarType: 'month', // or 'agenda'
  calendarPeriod: 'Future', // 'Future', 'Historical'
};

const calendarEvents = {
  /* Upcoming Calendar Events */
  calendarEventEmails: [],
  calendarEventNotifications: [],
  calendarEventEmailChanges: [],

  /* Past Calendar Events */
  pastEventEmails: [],
  pastEventNotifications: [],
  pastEventEmailChanges: [],
  pastEventNotificationChanges: [],
};

const customers = {
  rowsPerPage: 5,
  totalNonFree: 0,
  totalTrial: 0,
  totalPaying: 0,
};

const integrations = {
  emailIntegrationInfo: {},
  emailIntegration: '', // 'PK', 'SendGrid', 'SMTP'
};

const liveEvents = {
  webhookSettings: {
    expiredTrialEmails: {},
    pastDueEmails: {},
    unpaidEmails: {},
    successfulUpdates: 0,
  },
  webhookSettingsCopy: {
    expiredTrialEmails: {},
    pastDueEmails: {},
    unpaidEmails: {},
    successfulUpdates: 0,
  },
};

const metrics = {
  metricsExpanded: [],
};

const navigation = {
  sidebarOpen: true,
};

const paymentCollection = {
  paymentCollectionData: {
    checkout_image_url: '',
    prompt: '',
    subscription_describer: '',
    successful_updates_count: 0,
    title: '',
    type: '',
  },
  previewData: {
    formImageUrl: '',
    formPrompt: '',
    formSubscriptionDescriber: '',
    formTitle: '',
  },
  paymentInfo: {
    hashedId: '',
    customer: '',
    subscription: '',
  },
  formInfo: {
    customerEmail: '',
    formData: {},
    publicAPIKey: '',
    stripeData: {},
  },
  isPreview: false,
};

const session = {
  sessionExists: false,
  authHeader: '',
};

const historicalMetrics = {
  historicalMetricsFilter: null, // { date: "February 2025", type: "EXISTING", downgrades: false, upgrades: false}
};

const emailCampaign = {
  emailCampaignInCreation: null,
};

const state = {
  ...account,
  ...automatedEmails,
  ...calendar,
  ...calendarEvents,
  ...customers,
  ...integrations,
  ...liveEvents,
  ...metrics,
  ...navigation,
  ...paymentCollection,
  ...session,
  ...historicalMetrics,
  ...emailCampaign,
};

export default state;
